import React from "react";
import Header from "../../Layout/header";
import Footer from "../../Layout/footer";
import Projects from "../../components/projects";

function index() {
  return (
    <div>
    <Header />
    <div className="grid grid-cols-12">
      <div className="col-span-11 w-[95vw]">
        <Projects />
      </div>
      <div className="">
        <Footer />
      </div>
    </div>
  </div>
  );
}

export default index;
